import { connect } from 'react-redux'
import * as action from '../../state/correction/action'
import * as selector from '../../state/correction/selector'

import InvoiceCorrection from '../correction/InvoiceCorrection'


const mapStateToProps = (state, props) => {
    return {
        ...selector.selectOwnState(state),
    }
}

const mapDispatchToProps = {
    showConfirmationModal: action.showConfirmationModal,
    closeConfirmationModal: action.closeConfirmationModal,
    changeInvoiceCorrectionItem: action.changeInvoiceCorrectionItem,
    createInvoiceCorrection: action.createInvoiceCorrection,
    changeInvoiceCorrectionData: action.changeInvoiceCorrectionData,
}


export default connect(mapStateToProps, mapDispatchToProps)(InvoiceCorrection)



// WEBPACK FOOTER //
// ./src/modules/invoice/component/task-widget/InvoiceCorrectionWidgetContainer.js